export const GET_BRANCHES = "get_branches";
export const GET_MONTH_PLANS = "get_month_plans";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const GET_USER_DATA = "get_user_data";
export const GET_MONTH_PLANS_PDF = "get_month_plan";
export const GET_MONTH_PLANS_SHEET = "get_month_plan_sheet";
export const ERROR = "error";
